/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
import api from '../../../services/api';
import { WorkplanStatus } from '../../../Enums';

const API_URL = '/api/v1/manager/workplan';

/**
 * @param {string} bidProfileId
 * @param {WorkplanStatus} workplanStatus
 * @returns {Promise<ApiManager.GetAllWorkplanResponse>}
 */
export const getWorkplans = (bidProfileId, workplanStatus = WorkplanStatus.NotStarted) => api.post(API_URL, { bidProfileId, workplanStatus });

/**
 * @param {string} bidProfileId
 * @returns {Promise<ApiManager.GetWorkplanPublishProgressResponse>}
 */
export const GetWorkplanPublishProgress = (bidProfileId) => api.get(`${API_URL}/publish/${bidProfileId}/status`);
